// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDealer} from '../../../product/shared/repositories';

export const readDealer = account =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            if (account) {

                const dealer = await getDealer(account);

                dispatch({
                    dealer,
                    type: actions.UPDATE_NEW_TRANSFER_NEW_DEALER
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };




// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/read-dealer.js